<template>
  <footer class="harit-footer">
    <div>
      &copy; {{ new Date().getFullYear() }} HCL Foundation. All rights reserved.
    </div>

    <div class="harit-footer-versions">
      <span class="harit-footer-chip" title="Admin panel build">UI v{{ uiVersion }}</span>
      <span class="harit-footer-chip" :title="apiTitle">API {{ apiVersion ? 'v' + apiVersion : 'unavailable' }}</span>
    </div>

    <div class="harit-footer-credit">
      Developed by
      <a href="http://strofes.com/" target="_blank" rel="noopener">Strofes Technologies</a>
      for
      <a href="https://www.hclfoundation.org" target="_blank" rel="noopener">HCL Foundation</a>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
import store from '../store'

export default {
  name: 'AppFooter',
  data() {
    return {
      // Injected at build time from package.json by vue.config.js, so the
      // footer can never drift from the build that is actually deployed.
      uiVersion: process.env.VUE_APP_VERSION || 'dev',
      apiVersion: null,
      apiStartedAt: null,
    }
  },
  computed: {
    apiTitle() {
      return this.apiStartedAt
        ? 'API running since ' + new Date(this.apiStartedAt).toLocaleString()
        : 'Backend version could not be read'
    },
  },
  created() {
    this.getApiVersion()
  },
  methods: {
    // Unauthenticated on purpose - the footer renders on the login page too.
    getApiVersion() {
      axios({ url: store.state.baseURL + 'version', method: 'GET' })
        .then((res) => {
          if (res.data && res.data.status) {
            this.apiVersion = res.data.version
            this.apiStartedAt = res.data.startedAt
          }
        })
        .catch(() => {
          this.apiVersion = null
        })
    },
  },
}
</script>

<style lang="scss">
.harit-footer {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 2.25rem;
  border-top: 1px solid var(--harit-border);
  background: #fff;
  font-size: 0.85rem;
  color: var(--harit-ink-muted);

  @media (max-width: 768px) {
    padding: 1rem;
    justify-content: center;
    text-align: center;
  }

  a {
    color: var(--harit-green);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .harit-footer-credit {
    margin-left: auto;

    @media (max-width: 768px) {
      margin-left: 0;
    }
  }

  .harit-footer-versions {
    display: flex;
    gap: 0.4rem;
  }

  .harit-footer-chip {
    padding: 0.15rem 0.55rem;
    border-radius: 999px;
    background: #eef1f3;
    color: #5b6670;
    font-size: 0.78rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    cursor: default;
  }
}
</style>
